import React, { Component } from 'react';
import MessageItem from './MessageItem';

const container = React.createRef();

class TchatContainer extends Component {
    constructor(props){
        super(props);
    }

    componentDidUpdate(){
        container.current.scrollTo(0, container.current.scrollHeight);
    }

    render(){
        return (
            <div 
                id='tchat_messagesContainer' 
                ref={container}
            >
                { 
                    this.props.messages.map((item, index)=>{
                        return (
                            <MessageItem key={`message ${index}`} item={item} showUser={true} />
                        );
                    })
                }
            </div>
        );
    }
}

export default TchatContainer;